import { FormGroup, FormControl, FormArray } from "@angular/forms";
import { PolygonElement } from "../polygon-element";
import { PropertyMetadata } from "../../properties/property-types";
import { LevelDesignerElementBase } from "../element-base";
import { RegisterElement } from "../element-decorator";
import { v4 as uuidv4 } from 'uuid';

@RegisterElement()
export class Gate extends PolygonElement {
    layerIndex: number = 2;
    public override TypeName: string = "Gate";
    public override ParentType: string | null = "ParkingLevel";
    public override ParentFormGroupName: string | null = "Gates";
    constructor(formGroup: FormGroup) {
        super(formGroup);
        this.OutlineColor = '#4CA64C';  // Green
        this.FillColor = 'rgba(76, 166, 76, 0.2)';
        
        
        
        if (!formGroup.contains('Name')) {
            formGroup.addControl('Name', new FormControl(''));
        }
       

        if (!formGroup.contains('Lanes')) {
            formGroup.addControl('Lanes', new FormArray([]));
        }
    }

    public override clone(): Gate {
        return new Gate(this.formGroup);
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            {
                formControlName: 'Name',
                displayName: 'Name',
                inputType: { type: 'text' },
                description: 'Name of the gate',
                order: 1,
                category: 'General'
            },
        
        ];
    }

    public override default(): Gate {
        this.points = [
            { x: 0, y: 0 },
            { x: 6, y: 0 },
            { x: 6, y: 10 },
            { x: 0, y: 10 }
        ];

        // Now patch values to the existing controls
        this.formGroup.patchValue({
            Name: '',
            PolygonPoints: this.points.map(p => [p.x / 1000, p.y / 1000]),
        });

        return this;
    }

} 
